import * as React from 'react'
import * as ReactRedux from 'react-redux'
import PropTypes from 'prop-types'

import * as Configuration from './configuration'
import * as Session from './session'
import { RealityCheckModal } from './reality-check-modal'

export function RealityCheck(props) {
  const [shouldDisplay, setShouldDisplay] = React.useState(false)

  const gameServerUrl = ReactRedux.useSelector(state =>
    Configuration.getGameServerUrl(state.configuration)
  )
  const authenticated = ReactRedux.useSelector(state =>
    Session.isAuthenticated(state.session)
  )

  React.useEffect(() => {
    function showRealityCheck(event) {
      const action = event.data || {}
      if (action.type === '@rushplay/gamer/REALITY_CHECK_TRIGGERED') {
        return setShouldDisplay(true)
      }
    }

    window.addEventListener('message', showRealityCheck)

    return function cleanup() {
      window.removeEventListener('message', showRealityCheck)
    }
  }, [setShouldDisplay])

  function onDismiss() {
    props.iframeRef.current.contentWindow.postMessage(
      {
        type: '@rushplay/gamer/REALITY_CHECK_RESET',
      },
      gameServerUrl
    )
    setShouldDisplay(false)
  }

  if (!authenticated || !shouldDisplay) {
    return null
  }

  return <RealityCheckModal handleDismiss={onDismiss} />
}

RealityCheck.propTypes = {
  iframeRef: PropTypes.object.isRequired,
}
